import { Select, Tag} from 'antd';
import React, {useEffect, useState} from 'react';
import ajaxUtil from '../../util/ajax';
const {DOMAIN_CURRENT, ajaxv2, ajax} = ajaxUtil;

const { Option } = Select;


// 缓存数据，避免多次请求什么的
window.__cached_video_list = null;
export default function MultiVideoSelect(props){
    const {value, onChange, actionParams} = props;
    const [list, setList] = useState([]);

    const getList = async function (){
      const gallery = window.decorateGetGallery();
      const res = window.__cached_video_list || await ajaxv2({
        url:DOMAIN_CURRENT + `/api/v2/gallerymedium/list`,
        method:'GET',
        data:Object.assign({
          page:1,
          page_size:100,
          gallery_id:gallery.id
        }, actionParams)
      }).then(res=>{
        return res.items;
      });
      window.__cached_video_list = res;
      let list = (res || []).map(it=>{
        return {
            key:it.id,
            name:it.desc,
        }
      });

      setList(list);
    }

    useEffect(()=>{
        getList();
        return ()=>{
            window.__cached_video_list = null;
        }
    },[]);

    const renderGalleryName = (one)=>{
      return <React.Fragment>
        {one.name}
      </React.Fragment>
    }

    return (
        <Select mode="tags" style={{ width: props.width }} value={value} onChange={onChange} tokenSeparators={[',']}>
            {list.map(one=>(
                <Option key={`${one.key}`}>{renderGalleryName(one)}</Option>
            ))}
        </Select>
    )
}



// WEBPACK FOOTER //
// ./src/components/Select/MultiVideoSelect.js